import React, { useState } from 'react';
import { Toaster } from 'react-hot-toast';

import { Header } from './layout/Header';
import { Footer } from './layout/Footer';
import { SideBar } from './layout/SideBar';
import { MainContent } from './layout/MainContent';
import { SubmissionForm } from './components/submission/SubmissionForm';
import { Results } from './components/Results';
import { DefaultPage } from './pages/DefaultPage';
import { TutorialPage } from './pages/TutorialPage';
import { DocumentationPage } from './pages/DocumentationPage';
import { Impressum } from './pages/Impressum';

import './App.css';


export default function App() {
  const [token, setToken] = useState(null);
  const [jobs, setJobs] = useState([]);
  const [page, setPage] = useState('default');
  const [toggle, setToggle] = useState(true);
  const [alert, setAlert] = useState(0);
  const alertOthers = () => setAlert(alert+1);

  console.info("Start up of App")
  console.debug("Currently displaying page", page)
  console.debug("Side bar toggle", toggle)
  console.debug(token)
  console.log('App set jobs:')
  console.log(jobs)

  if (token !== null) {
    console.info("Token set for authentication")
  }
  if (page === "results" && token === null) {
    setPage("default")
  }
  return (
    <div>
      <Header onClick={setPage}/>
      <div className="container-fluid">
        <div className="row" style={{height: '100%'}}>
          <div className={toggle ? 'col-11 col-md-5 col-xl-3' : 'd-none'}
          style={{padding: 0}}
          >
            <SideBar>
              <SubmissionForm
                token={token}
                setToken={setToken}
                jobs={jobs}
                onSubmit={(jobs) => {
                  setPage('results');
                  setJobs(jobs);
                  alertOthers()
                }}
              />
            </SideBar>
          </div> 
          <div className="col-1 d-grid toggle-part">
            <button 
              className="btn btn-block toggle-button"
              onClick={e => {e.preventDefault(); setToggle(!toggle)}} 
            >
                {toggle ? "<" : ">"}
            </button>
          </div>
          <div className="col">
            <Toaster />
            <MainContent>
              { page === 'default' && <DefaultPage setToken={setToken} setPage={setPage}/> }
              { page === 'tutorial' && <TutorialPage setToken={setToken}/> }
              { page === 'documentation' && <DocumentationPage /> }
              { page === 'impressum' && <Impressum /> }
              { page === 'results' && token !== null && <Results token={token} activeJobs={jobs} alert={alert} onChange={alertOthers}/> }
            </MainContent>
          </div>
        </div>
        <div className="row">
          <Footer onClick={setPage}/>
        </div>
      </div>
    </div>
  );
}


